module.exports = __webpack_public_path__ + "fonts/BrittanySignature.b4d584e.ttf";